.banner {
	// `!important` beats the ui-library Alert's own spacing, the same escape SurveyNotification needs.
	@apply yst-mb-4 #{!important};
}

.body {
	p {
		@apply yst-max-w-[640px] yst-m-0 #{!important};
	}

	// A blank line before "Questions? Contact support." so it reads as a separate closing remark
	// rather than a fourth clause of the notice. A margin on the paragraph rather than an empty
	// element, so nothing is announced to a screen reader that a sighted reader does not see.
	.questions {
		@apply yst-mt-4 #{!important};
	}
}
